<app-header *ngIf="showHead"></app-header>
<app-spinner></app-spinner>
<app-idle-modal></app-idle-modal>
<app-order-summary-modal></app-order-summary-modal>
<app-order-submitted-modal></app-order-submitted-modal>
<app-order-unavailable-modal></app-order-unavailable-modal>
<app-invalid-basket-modal></app-invalid-basket-modal>
<router-outlet></router-outlet>